export default {
  "b2b.zakaznici-grid.label": "Customers"
};
